import { postContent } from "../../lib/fetchData";
import { IInventoryContext } from "./context";
import { InventoryPartialRequest } from "./ProductInventory/types";

export const ApiContext: IInventoryContext = {
  getStoresForCart: (request: IDeliveryAddress) => {
    return postContent<IDeliveryAddress, InventoryResult[]>(
      "/api/inventory/getstoresforcart",
      request,
    );
  },
  getInventory: (request: ProductInventoryRequest) => {
    return postContent<ProductInventoryRequest, InventoryResult[]>(
      "/api/inventory/getproductinventory",
      request,
    );
  },
  getPartialInventory: (request: InventoryPartialRequest) => {
    return postContent<InventoryPartialRequest, InventoryResult>(
      "/api/inventory/getvendorinventory2",
      request,
    );
  },
};
